import { render } from "./TeamList.vue?vue&type=template&id=192d24db&scoped=true"
import script from "./TeamList.vue?vue&type=script&lang=js"
export * from "./TeamList.vue?vue&type=script&lang=js"

import "./TeamList.vue?vue&type=style&index=0&id=192d24db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-192d24db"

export default script